import { regex } from './regex';
const validators = {
    email: (value) => regex.email.test(value),
    empty: (value) => value.replace(regex.spaces, "").length !== 0,
    phone: (value) => regex.phone.test(value),
    number: (value) => Number.isInteger(value),
    week: (value) => parseInt(value) >= -52 && parseInt(value) <= 52,
    password: (value) => value.replace(regex.spaces, "").length >= 8,
};
export const validate = (value, validatorsArr) => {
    if (!validatorsArr || !validatorsArr.length) {
        return true;
    }
    ;
    for (let i = 0; i < validatorsArr.length; i++) {
        const validator = validators[validatorsArr[i]];
        if (validator) {
            const valid = validator(value);
            if (!valid) {
                return false;
            }
        }
    }
    return true;
};
export const validateAll = (model, validatorsObject) => {
    const errors = [];
    for (const key in validatorsObject) {
        const valid = validate(model[key], validatorsObject[key]);
        if (!valid) {
            errors.push({ key: key, valid: false });
        }
    }
    return errors;
};
